module.exports = __webpack_public_path__ + "assets/img/icon-act-7463b9df.png";